export default __webpack_public_path__ + "static/media/community_default_image.8ce05960.svg";